export default "/staticreactui/static/media/static/media/customer0.f77933de.png";